import Vue from 'vue';
import Auth from '@js/plugins/auth';

Vue.component('report-fuel-index', () =>
    import(/* webpackChunkName: 'report-fuel-index' */ './report-fuel-index.vue'),
);

Vue.component('report-pttm', () =>
    import(/* webpackChunkName: 'report-pttm' */ './report-pttm.vue'),
);

Vue.component('report-movement-index', () => {
    if (Auth.metas().environment === 'bhp') {
        return import(/* webpackChunkName: 'report-movement-index-bhp' */ './bhp/report-movement-index.vue');
    }

    return import(/* webpackChunkName: 'report-movement-index' */ './report-movement-index.vue');
});
